var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bi-cohorts',{attrs:{"entities":_vm.entities,"affiliates":_vm.affiliates,"report":_vm.report,"report-settings":_vm.reportSettings,"is-loading":_vm.isLoading},on:{"request-affiliates":_vm.loadAffiliates,"request-report":_vm.onRequestReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }